import { Color, Font } from "@styles/constants";
import { BodyMediumCSS } from "@styles/typography";
import styled from "styled-components";

export const FormContainer = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${Color.black40};
`;

export const FormSection = styled.section`
  padding-bottom: 10px;
  font-family: ${Font.regular};
   {
    div {
      .StripeElement {
        height: auto;
        margin-top: 10px;
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 75%;
  margin-left: auto;
  margin-right: auto;
`;

export const BodyText = styled.p`
  ${BodyMediumCSS}
  width: 75%;
  margin-left: auto;
  margin-right: auto;
`;
